import { SET_MODULE_DATA_FILTER } from 'root/src/client/logic/api/actionIds'

export default payload => ({
	type: SET_MODULE_DATA_FILTER,
	payload,
})
